export const SCREEN_SIZES = {
  landscapeMobile: 576,
  tablet: 768,
  desktop: 992,
  largeDesktop: 1200,
};

export const isMobile = () => window.innerWidth <= SCREEN_SIZES.landscapeMobile;
